import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BulkImportInitResponse,
  BulkImportInvalidResponse,
  BulkImportRequest,
  BulkImportStatusResponse,
  BulkImportType
} from '@dr-customer-offers-ui/lib-interfaces';
import { Observable } from 'rxjs';
import { ApiEndpointsService } from '../api-endpoint/api-endpoints.service';

@Injectable({ providedIn: 'root' })
export class ComBulkImportService {
  constructor(
    private http: HttpClient,
    private apiService: ApiEndpointsService
  ) {}

  postOffersBulkImport(registration_id: string, import_name: string): Observable<BulkImportInitResponse> {
    const url = `${this.apiService.baseUrlV2}/registrations/${registration_id}/offers/bulk-import`;
    const body: BulkImportRequest = { import_name, registration_id, import_type: BulkImportType.Offers };
    return this.http.post<BulkImportInitResponse>(url, body, { withCredentials: true });
  }

  postClearedOffersBulkImport(registration_id: string, import_name: string): Observable<BulkImportInitResponse> {
    const url = `${this.apiService.baseUrlV2}/registrations/${registration_id}/offers/clear/bulk-import`;
    const body: BulkImportRequest = { import_name, registration_id, import_type: BulkImportType.CLEAR_OFFER };
    return this.http.post<BulkImportInitResponse>(url, body, { withCredentials: true });
  }

  postBaselinesBulkImport(registration_id: string, import_name: string): Observable<BulkImportInitResponse> {
    const url = `${this.apiService.baseUrlV2}/registrations/${registration_id}/baselines/bulk-import`;
    const body: BulkImportRequest = { import_name, registration_id, import_type: BulkImportType.Baselines };
    return this.http.post<BulkImportInitResponse>(url, body, { withCredentials: true });
  }

  getOffersBulkImportStatus(registration_id: string, import_id: string): Observable<BulkImportStatusResponse> {
    const url = `${this.apiService.baseUrlV2}/registrations/${registration_id}/offers/bulk-import/${import_id}`;
    return this.http.get<BulkImportStatusResponse>(url, { withCredentials: true });
  }

  getClearedOffersBulkImportStatus(registration_id: string, import_id: string): Observable<BulkImportStatusResponse> {
    const url = `${this.apiService.baseUrlV2}/registrations/${registration_id}/offers/clear/bulk-import/${import_id}`;
    return this.http.get<BulkImportStatusResponse>(url, { withCredentials: true });
  }

  getBaselinesBulkImportStatus(registration_id: string, import_id: string): Observable<BulkImportStatusResponse> {
    const url = `${this.apiService.baseUrlV2}/registrations/${registration_id}/baselines/bulk-import/${import_id}`;
    return this.http.get<BulkImportStatusResponse>(url, { withCredentials: true });
  }

  getOffersBulkImportInvalid(registration_id: string, import_id: string): Observable<BulkImportInvalidResponse> {
    const url = `${this.apiService.baseUrlV2}/registrations/${registration_id}/offers/bulk-import/${import_id}/invalid`;
    return this.http.get<BulkImportInvalidResponse>(url, { withCredentials: true });
  }

  getClearedOffersBulkImportInvalid(registration_id: string, import_id: string): Observable<BulkImportInvalidResponse> {
    const url = `${this.apiService.baseUrlV2}/registrations/${registration_id}/offers/clear/bulk-import/${import_id}/invalid`;
    return this.http.get<BulkImportInvalidResponse>(url, { withCredentials: true });
  }

  getBaselinesBulkImportInvalid(registration_id: string, import_id: string): Observable<BulkImportInvalidResponse> {
    const url = `${this.apiService.baseUrlV2}/registrations/${registration_id}/baselines/bulk-import/${import_id}/invalid`;
    return this.http.get<BulkImportInvalidResponse>(url, { withCredentials: true });
  }
}
